export function sendGtagEvent(action, parameters) {
  /* global gtag: true */
  if (typeof gtag !== 'undefined') {
    gtag('event', action, parameters)
  }
}